import { render, staticRenderFns } from "./documentVersion.vue?vue&type=template&id=f003df0a&scoped=true&"
import script from "./documentVersion.vue?vue&type=script&lang=js&"
export * from "./documentVersion.vue?vue&type=script&lang=js&"
import style0 from "./documentVersion.vue?vue&type=style&index=0&id=f003df0a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f003df0a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f003df0a')) {
      api.createRecord('f003df0a', component.options)
    } else {
      api.reload('f003df0a', component.options)
    }
    module.hot.accept("./documentVersion.vue?vue&type=template&id=f003df0a&scoped=true&", function () {
      api.rerender('f003df0a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/customerService/documentVersion.vue"
export default component.exports